/** NEW UI theme */

import { AppTheme } from './types';

// Define the typography structure
const typography = {
  h1: {
    fontSize: '40px',
    fontWeight: 700,
    lineHeight: 1.2,
  },
  h2: {
    fontSize: '32px',
    fontWeight: 700,
    lineHeight: 1.2,
  },
  h3: {
    fontSize: '28px',
    fontWeight: 700,
    lineHeight: 1.2,
  },
  h4: {
    fontSize: '24px',
    fontWeight: 700,
    lineHeight: 1.2,
  },
  h5: {
    fontSize: '20px',
    fontWeight: 600,
    lineHeight: 1.2,
  },
  h6: {
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: 1.2,
  },
  'body-16': {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  'body-14': {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  'body-12': {
    fontSize: '13px',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  'body-10': {
    fontSize: '10px',
    fontWeight: 400,
    lineHeight: 1.5,
  },
};

export const gmsThemeLight: AppTheme = {
  name: 'gms-theme-light',
  colors: {
    primary: {
      normal: '#00C072',
      medium: '#00A361',
      dark: '#00483B',
    },
    secondary: {
      normal: '#E6F8F1',
      medium: '#C2F0DD',
      dark: '#99E6C7',
    },
    background: {
      light: '#F8F8F7',
      medium: '#F2F2F2',
      dark: '#E8E8E8',
    },
    technical: {
      adaptive: '#131313',
      'adaptive-reverse': '#FFFFFF',
      black: '#040404',
      gray: {
        60: '#6B6B6B',
        30: '#B3B3B3',
        15: '#D9D9D9',
        5: '#F2F2F2',
      },
      white: '#FFFFFF',
    },
    status: {
      success: {
        normal: '#00C072',
        highlight: '#E6F8F1',
        light: '#C2F0DD',
        dark: '#99E6C7',
      },
      error: {
        normal: '#FF5959',
        highlight: '#FFE5E5',
        light: '#FFA8A8',
        dark: '#DC0000',
      },
      warning: {
        normal: '#FF7801',
        highlight: '#FFF9EB',
        light: '#FFBB66',
        dark: '#BF5F00',
      },
      info: {
        normal: '#00A4FF',
        highlight: '#E6F6FF',
        light: '#99CFFF',
        dark: '#006BC9',
      },
    },
    decorative: {
      forest: '#00DFAF',
      frost: '#C480FF',
      babyPink: '#FFB4F9',
      ultraViolet: '#808FFF',
      sea: '#80C6FF',
      barbiePink: '#FF80C6',
      honey: '#FFA641',
      leaf: '#80FFAC',
      indigo: '#004BA0',
      background: {
        forest: '#CCFFF4',
        frost: '#F3E5FF',
        babyPink: '#FFE5FD',
        ultraViolet: '#E5E9FF',
        sea: '#E5F4FF',
        barbiePink: '#FFE5F4',
        honey: '#FFF3E5',
        leaf: '#E5FFEE',
        indigo: '#E5F1FF',
      },
    },
  },
  typography,
};

export const gmsThemeDark: AppTheme = {
  name: 'gms-theme-dark',
  colors: {
    primary: {
      normal: '#00C072',
      medium: '#00D583',
      dark: '#00F098',
    },
    secondary: {
      normal: '#1A261F',
      medium: '#273830',
      dark: '#334A40',
    },
    background: {
      light: '#1A1A1A',
      medium: '#121212',
      dark: '#080808',
    },
    technical: {
      adaptive: '#FFFFFF',
      'adaptive-reverse': '#131313',
      black: '#040404',
      gray: {
        60: '#999999',
        30: '#4D4D4D',
        15: '#262626',
        5: '#0D0D0D',
      },
      white: '#FFFFFF',
    },
    status: {
      success: {
        normal: '#00C072',
        highlight: '#E6F8F1',
        light: '#C2F0DD',
        dark: '#99E6C7',
      },
      error: {
        normal: '#FF7070',
        highlight: '#3A2222',
        light: '#FFA8A8',
        dark: '#DC0000',
      },
      warning: {
        normal: '#FF9933',
        highlight: '#3A2E1A',
        light: '#FFBB66',
        dark: '#BF5F00',
      },
      info: {
        normal: '#33B1FF',
        highlight: '#1A2A3A',
        light: '#99CFFF',
        dark: '#006BC9',
      },
    },
    decorative: {
      forest: '#00DFAF',
      frost: '#C480FF',
      babyPink: '#FFB4F9',
      ultraViolet: '#808FFF',
      sea: '#80C6FF',
      barbiePink: '#FF80C6',
      honey: '#FFA641',
      leaf: '#80FFAC',
      indigo: '#004BA0',
      background: {
        forest: '#1A2922',
        frost: '#291A33',
        babyPink: '#331A2E',
        ultraViolet: '#1A1C33',
        sea: '#1A2633',
        barbiePink: '#331A26',
        honey: '#33271A',
        leaf: '#1A331F',
        indigo: '#1A2333',
      },
    },
  },
  typography,
};

export const gmsThemes = {
  light: gmsThemeLight,
  dark: gmsThemeDark,
};
